import { Alert, Text } from '@zillow/constellation-10';
import StringConstants from '../../constants/StringConstants';

export default function TourInfoUnavailableCard() {
  return (
    <Alert role="status" tone="warning">
      <Text textStyle="body-bold">{StringConstants.TOUR_INFO_UNAVAILABLE_TITLE}</Text>{' '}
      {StringConstants.TOUR_INFO_UNAVAILABLE_BODY}
    </Alert>
  );
}
